export default {
  clientCheckLoading: false,
  clientCheckError: false,
  clientCheckComplete: false,
  clientCheckResult: false,
  clientCheckMessage: ''
};
